import React from 'react';
import {useParams} from "react-router-dom";
import ArticleFormView from "../features/articles/views/article-form-view";
import PreviewArticleModal from "../features/articles/components/preview-article-modal";
import DeleteArticleModal from "../features/articles/components/delete-article-modal";
import UniversalArticleDeleteInfoModal from "../features/articles/components/universal-article-delete-info-modal";
import ArticleToPrintModal from "../features/articles/components/article-to-print-modal";
import ArticleQrInfoModal from "../features/articles/components/article-qr-info-modal";
import ShareArticleModal from "../features/articles/components/share-article-modal";
import ConvertDocumentAiModal from "../features/articles/components/convert-document-ai-modal";
import AiConvertedArticleModal from "../features/articles/components/ai-converted-article-modal";
import AiErrorResponseModal from "../features/articles/components/ai-error-response-modal";

const ArticleFormPage: React.FC = () => {
    const {id} = useParams<{ id: string }>();

    return (
        <div className="w-full max-h-full overflow-y-auto">
            <div className="px-6 py-[80px] max-w-[848px] mx-auto">
                <ArticleFormView articleId={id}/>
            </div>
            <PreviewArticleModal titleBackButton="Podgląd arytukułu"/>
            <ArticleToPrintModal/>
            <ArticleQrInfoModal/>
            <DeleteArticleModal/>
            <ShareArticleModal/>
            <ConvertDocumentAiModal/>
            <AiConvertedArticleModal/>
            <AiErrorResponseModal/>
            <UniversalArticleDeleteInfoModal/>
        </div>
    );
};

export default ArticleFormPage;


